import { PageMeta } from "@/components/common/Seo/PageMeta"
import ExplorerPage from "@/components/products/explorer/ExplorerPage"
import { ProductSchema } from "@/components/products/ProductSchema"

const index = () => (
  <>
    <ProductSchema id="explorer" />
    <PageMeta
      meta={{
        title: "Explorer: onchain metrics for crypto",
        description:
          "Browse standardized financial and usage metrics for thousands of blockchains, apps and tokenized assets with no code. Open the Token Terminal Explorer for free.",
      }}
    />
    <ExplorerPage />
  </>
)

export default index
